import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { HelpCategoryDto, GET_HELP_CATEGORIES_QUERY_KEY } from './useHelpCategories';

export type UpdateHelpCategoryInput = {
  nameEn?: string;
  nameFr?: string;
  descriptionEn?: string;
  descriptionFr?: string;
  slug?: string;
  icon?: string;
  sortOrder?: number;
};

export const useUpdateHelpCategory = (onSuccess: () => void) => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...input }: UpdateHelpCategoryInput & { id: string }) =>
      client.fetchApi<HelpCategoryDto, UpdateHelpCategoryInput>({ endpoint: `help/admin/categories/${id}`, method: 'PUT', body: input }),
    onSuccess: () => {
      queryClient.invalidateQueries(GET_HELP_CATEGORIES_QUERY_KEY);
      onSuccess();
    },
  });
};
